(() => {
  const SELECTOR = '[data-sales-home-variant]';

  const setSlide = (carousel, nextIndex, userInitiated = false) => {
    const slides = Array.from(carousel.querySelectorAll('[data-sales-slide]'));
    const controlsRoot = carousel.closest('.ingenio-home-sales') || carousel;
    const dots = Array.from(controlsRoot.querySelectorAll('[data-sales-dot]'));
    if (!slides.length) return;

    const index = (nextIndex + slides.length) % slides.length;
    carousel.dataset.activeIndex = String(index);
    carousel.style.setProperty('--sales-slide-index', String(index));

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      slide.querySelectorAll('a, button, input, select').forEach((control) => {
        if (active) control.removeAttribute('tabindex');
        else control.setAttribute('tabindex', '-1');
      });
    });

    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.setAttribute('aria-current', active ? 'true' : 'false');
      dot.setAttribute('aria-label', `${active ? 'Diapositiva actual' : 'Ir a diapositiva'} ${dotIndex + 1}`);
    });

    if (userInitiated) carousel.dataset.userPaused = 'true';
  };

  const initHeroCarousel = (carousel) => {
    if (carousel.dataset.salesReady === 'true') return;
    carousel.dataset.salesReady = 'true';

    const slides = carousel.querySelectorAll('[data-sales-slide]');
    const controlsRoot = carousel.closest('.ingenio-home-sales') || carousel;
    const go = (delta, userInitiated = true) => {
      const current = Number(carousel.dataset.activeIndex || 0);
      setSlide(carousel, current + delta, userInitiated);
    };

    controlsRoot.querySelector('[data-sales-prev]')?.addEventListener('click', () => go(-1));
    controlsRoot.querySelector('[data-sales-next]')?.addEventListener('click', () => go(1));
    controlsRoot.querySelectorAll('[data-sales-dot]').forEach((dot) => {
      dot.addEventListener('click', () => setSlide(carousel, Number(dot.dataset.salesDot), true));
    });

    carousel.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') go(-1);
      if (event.key === 'ArrowRight') go(1);
    });

    setSlide(carousel, 0);

    const interval = Number(carousel.dataset.autoplaySeconds || 0);
    if (interval >= 4 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && slides.length > 1) {
      window.setInterval(() => {
        if (carousel.dataset.userPaused === 'true' || document.hidden) return;
        go(1, false);
      }, interval * 1000);
    }
  };

  const initProductRail = (rail) => {
    if (rail.dataset.salesReady === 'true') return;
    rail.dataset.salesReady = 'true';
    const scroller = rail.querySelector('[data-sales-scroller]');
    if (!scroller) return;
    const controlsRoot = rail.closest('.ingenio-home-sales') || rail;

    const distance = () => {
      const card = scroller.querySelector('.ihs-product-card');
      if (!card) return scroller.clientWidth;
      const styles = window.getComputedStyle(scroller);
      return card.getBoundingClientRect().width + Number.parseFloat(styles.columnGap || styles.gap || 0);
    };

    controlsRoot.querySelector('[data-sales-prev]')?.addEventListener('click', () => {
      scroller.scrollBy({ left: -distance() * (window.innerWidth >= 990 ? 4 : 2), behavior: 'smooth' });
    });
    controlsRoot.querySelector('[data-sales-next]')?.addEventListener('click', () => {
      scroller.scrollBy({ left: distance() * (window.innerWidth >= 990 ? 4 : 2), behavior: 'smooth' });
    });
  };

  const initVariantSelect = (select) => {
    if (select.dataset.salesReady === 'true') return;
    select.dataset.salesReady = 'true';

    const card = select.closest('.ihs-product-card');
    const input = card?.querySelector('input[name="id"]');
    const button = card?.querySelector('[data-sales-add]');
    const price = card?.querySelector('[data-sales-price]');
    if (!input || !button) return;

    const update = () => {
      const option = select.options[select.selectedIndex];
      input.value = option.value;
      button.disabled = option.disabled;
      if (price && option.dataset.price) {
        const discount = Number(option.dataset.discount || 0);
        const onSale = discount > 0;
        const current = price.querySelector('[data-sales-current]');
        const compare = price.querySelector('[data-sales-compare]');
        const priceLabel = price.querySelector('[data-sales-price-label]');
        const badge = card.querySelector('[data-sales-sale-badge]');
        price.classList.toggle('ihs-product-card__price--sale', onSale);
        if (current) current.textContent = option.dataset.price;
        if (priceLabel) priceLabel.textContent = option.dataset.priceLabel;
        if (compare) {
          compare.hidden = !onSale;
          compare.querySelector('s').textContent = option.dataset.compare || '';
        }
        if (badge) {
          badge.hidden = !onSale;
          badge.querySelector('[data-sales-discount]').textContent = String(discount);
        }
      }
      const label = button.querySelector('[data-sales-add-label]');
      if (label) label.textContent = option.disabled ? 'Agotado' : 'Agregar al carrito';
    };

    select.addEventListener('change', update);
    update();
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTOR).forEach((home) => {
      const variant = (home.dataset.salesHomeVariant || '').toLowerCase();
      if (variant) document.body.classList.add(`ingenio-sales-${variant}`);
    });
    root.querySelectorAll('[data-sales-carousel]').forEach(initHeroCarousel);
    root.querySelectorAll('[data-sales-product-rail]').forEach(initProductRail);
    root.querySelectorAll('[data-sales-variant-select]').forEach(initVariantSelect);
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

